import { ChangeMeta, PagedResponse, PatchWithMeta, QueryParams } from "@ofqual/portal-core/core/types";
import { AnyAction } from "redux";
import { InformationRequestAction } from "../domain/InformationRequestAction";
import { AssignUser } from "../domain/AssignUser";
import { InformationRequest } from "../domain/InformationRequest";
import { Message } from "../domain/Message";
import { Recipient } from "../domain/Recipient";
import {
  RecipientOrg,
  RecipientPotentiallyUnknownOrg,
  RecipientsViewModel,
} from "../domain/RecipientsViewModel";
import { MODULE_NAME } from "../moduleName";
import { RecipientsState } from "./state";
import { ActionsState } from "./state";
export interface ActionPayload<T> extends AnyAction {
  type: string;
  payload: T;
}

export const LOADED_ITEMS = `${MODULE_NAME}/LOADED_ITEMS`;
export const LOADING_ITEMS = `${MODULE_NAME}/LOADING_ITEMS`;

export const LOADED_ITEM = `${MODULE_NAME}/LOADED_ITEM`;
export const LOADING_ITEM = `${MODULE_NAME}/LOADING_ITEM`;
export const SAVED_ITEM = `${MODULE_NAME}/SAVED_ITEM`;

export const UPDATING_ITEM = `${MODULE_NAME}/UPDATING_ITEM`;
export const UPDATING_ITEM_VALIDATION_FAIL = `${MODULE_NAME}/UPDATING_ITEM_VALIDATION_FAIL`;

export const SENDING_ITEM = `${MODULE_NAME}/SENDING_ITEM`;
export const SENT_ITEM = `${MODULE_NAME}/SENT_ITEM`;

export const LOADING_RECIPIENTS = `${MODULE_NAME}/LOADING_RECIPIENTS`;
export const LOADED_RECIPIENTS = `${MODULE_NAME}/LOADED_RECIPIENTS`;
export const UPDATING_RECIPIENTS = `${MODULE_NAME}/UPDATING_RECIPIENTS`;
export const TOGGLE_SELECT_RECIPIENT = `${MODULE_NAME}/TOGGLE_SELECT_RECIPIENT`;
export const LOADING_ACTIONS = `${MODULE_NAME}/LOADING_ACTIONS`;
export const LOADED_ACTIONS = `${MODULE_NAME}/LOADED_ACTIONS`;
export const CREATING_ACTION = `${MODULE_NAME}/CREATING_ACTION`;
export const UPDATING_ACTION = `${MODULE_NAME}/UPDATING_ACTION`;
export const DELETING_ACTION = `${MODULE_NAME}/DELETING_ACTION`;
export const ASSIGN_USERS = `${MODULE_NAME}/ASSIGN_USERS`;
export const SEND_MESSAGE_TO_RECIPIENTS = `${MODULE_NAME}/SEND_MESSAGE_TO_RECIPIENTS`;
export const CREATING_DOCUMENT_ACTION = `${MODULE_NAME}/CREATING_DOCUMENT_ACTION`;
export const CREATING_MESSAGE_ACTION = `${MODULE_NAME}/CREATING_MESSAGE_ACTION`;
export const SEND_MESSAGE = `${MODULE_NAME}/SEND_MESSAGE`;
export const UPDATE_AO_USERS = `${MODULE_NAME}/UPDATE_AO_USERS`;
export const ASSIGN_AO_USER = `${MODULE_NAME}/ASSIGN_AO_USER`;
export const CLOSE_RECIPIENTS = `${MODULE_NAME}/CLOSE_RECIPIENTS`
export const DELETING_ITEM = `${MODULE_NAME}/DELETING_ITEM`;
export const READING_DOCUMENTS_ACTION = `${MODULE_NAME}/READING_DOCUMENTS_ACTION`;
export const MARK_RESPONSE_AS_COMPLETE = `${MODULE_NAME}/MARK_RESPONSE_AS_COMPLETE`;
export const MARK_UPLOAD_AS_COMPLETE = `${MODULE_NAME}/MARK_UPLOAD_AS_COMPLETE`;


export const loadedItems = (payload: PagedResponse<InformationRequest>) => ({
  type: LOADED_ITEMS,
  payload,
});
export const loadingItems = (payload: QueryParams) => ({
  type: LOADING_ITEMS,
  payload,
});

export const loadedItem = (item: InformationRequest) => ({
  type: LOADED_ITEM,
  payload: item,
});

export const loadingItem = (id: string) => ({
  type: LOADING_ITEM,
  payload: id,
});


export const deletingItem = (id: string) => ({
  type: DELETING_ITEM,
  payload: id,
});


export const updatingItem = (
  id: string,
  patchWithMeta: PatchWithMeta<InformationRequest>,
  resourceTagsIds: number[]
) => ({
  type: UPDATING_ITEM,
  payload: { id, patchWithMeta, resourceTagsIds },
});

export const updatedItem = (item: InformationRequest) => ({
  type: SAVED_ITEM,
  payload: item,
});

export const sendingItem = (id: string) => ({
  type: SENDING_ITEM,
  payload: { id },
});

export const sentItem = (item: InformationRequest) => ({
  type: SENT_ITEM,
  payload: item,
});

export const loadingRecipients = (
  resourceId: RecipientsState["resourceId"]
) => ({
  type: LOADING_RECIPIENTS,
  payload: resourceId,
});

export const loadedRecipients = (
  resourceId: RecipientsState["resourceId"],
  recipients: Recipient[],
  viewModel: RecipientsViewModel
) => ({
  type: LOADED_RECIPIENTS,
  payload: { resourceId, recipients, viewModel },
});

export const updatingRecipients = (
  id: string,
  recipients: RecipientsViewModel<RecipientPotentiallyUnknownOrg>,
  patch: ChangeMeta[],

) => ({
  type: UPDATING_RECIPIENTS,
  payload: { id, recipients, patch },
});

export const toggleSelectRecipient = (recipients: RecipientOrg[]) => ({
  type: TOGGLE_SELECT_RECIPIENT,
  payload: {
    recipients,
  },
});

export const loadingActions = (resourceId: ActionsState["resourceId"]) => ({
  type: LOADING_ACTIONS,
  payload: resourceId,
});

export const loadedActions = (
  resourceId: ActionsState["resourceId"],
  actions: InformationRequestAction[]
) => ({
  type: LOADED_ACTIONS,
  payload: { resourceId, actions },
});

export const postAction = (
  id: string,
  files: File[],
  action: Partial<InformationRequestAction>
) => ({
  type: CREATING_ACTION,
  payload: { id, files, action },
});

export const editAction = (
  id: string,
  actionId: string,
  files: File[],
  attachmentIdsToDelete: string[],
  model: PatchWithMeta<InformationRequestAction>
) => ({
  type: UPDATING_ACTION,
  payload: { id, actionId, files, attachmentIdsToDelete, model },
});

export const deleteAction = (
  id: string,
  actionId: string,
) => ({
  type: DELETING_ACTION,
  payload: { id, actionId },
});


export const assignUsers = (resourceId: string, assignUsers: AssignUser[]) => ({
  type: ASSIGN_USERS,
  payload: { resourceId, assignUsers },
});

export const sendMessageToRecipients = (
  id: string,
  files: File[],
  message: Message
) => ({
  type: SEND_MESSAGE_TO_RECIPIENTS,
  payload: { id, files, message },
});

export const postDocumentAction = (
  id: string,
  orgRecipientId: string,
  itemId: string,
  actionId: string,
  files: File[]
) => ({
  type: CREATING_DOCUMENT_ACTION,
  payload: { id, orgRecipientId, itemId, actionId, files },
});

export const postMessageAction = (
  id: string,
  orgRecipientId: string,
  itemId: string,
  actionId: string,
  message: string
) => ({
  type: CREATING_MESSAGE_ACTION,
  payload: { id, orgRecipientId, itemId, actionId, message },
});

export const sendMessage = (
  id: string,
  orgRecipientId: string,
  files: File[],
  message: string
) => ({
  type: SEND_MESSAGE,
  payload: { id, orgRecipientId, files, message },
});

export const updateAoUsers = (
  id: string,
  orgRecipientId: string,
  itemId: string,
  users: { id: string; upn: string }[]
) => ({
  type: UPDATE_AO_USERS,
  payload: { id, orgRecipientId, itemId, users },
});

export const assignAoUser = (
  id: string,
  orgRecipientId: string,
  itemId: string,
  aoAssignedToUpn: string,
  aoAssignedToName: string
) => ({
  type: ASSIGN_AO_USER,
  payload: { id, orgRecipientId, itemId, aoAssignedToUpn, aoAssignedToName },
});

export const closeRecipients = (
  id: string,
  orgIds: string[]
) => ({
  type: CLOSE_RECIPIENTS,
  payload: { id, orgIds },
});

export const postReadDocuments = (
  id: string,
  orgRecipientId: string,
  itemId: string,
  actionId: string,
) => ({
  type: READING_DOCUMENTS_ACTION,
  payload: { id, orgRecipientId, itemId, actionId },
});

export const postMarkResponseComplete = (
  id: string,
  orgRecipientId: string,
  itemId: string,
  actionId: string,
) => ({
  type: MARK_RESPONSE_AS_COMPLETE,
  payload: { id, orgRecipientId, itemId, actionId },
});

export const postMarkUploadComplete = (
  id: string,
  orgRecipientId: string,
  itemId: string,
  actionId: string,
) => ({
  type: MARK_UPLOAD_AS_COMPLETE,
  payload: { id, orgRecipientId, itemId, actionId },
});